import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaTags,
  FaUserTie,
} from "react-icons/fa";
import { MdViewModule } from "react-icons/md";
import ProductDocuments from "../../../assets/Docs/ProductOffers.png";
import { TagComponent } from "../Tabs";

const ProductOffer = () => {
  const [activeTab1, setActiveTab1] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  const content1 = {
    web: "",
    mobile: "",
  };


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            } ${tab.disabled ? "opacity-50 cursor-not-allowed hover:bg-[#dbf4f1]" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">
      
      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaTags className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Product Offers</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <p className="text-start mb-6 text-gray-600 ">
        Attach important product documents such as manuals, warranty cards,
        compliance certificates, or any other supporting files.
        These documents help customers and team members access detailed information.
      </p>

      {renderTabs(activeTab1, setActiveTab1)}
      <div className="rounded-lg p-2 sm:p-4 flex justify-start">
        <img
          src={ProductDocuments}
          alt={`${activeTab1} view`}
          className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
        />
      </div>
    </div>
  );
};

export default ProductOffer;
